import { Banner } from 'component/Banner/Banner'
import { Button } from 'component/Button'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { measurements_banner } from 'feature/measurements/store'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { Genders } from 'page/ProfileScreen/Genders/Genders'
import { DetailedForm } from 'page/ProfileScreen/ProfileForm/DetailedForm'
import { SizesStep } from 'page/ProfileScreen/SizesStep/SizesStep'
import { controller } from 'store/controller'
import { store } from 'store/store'

type Props = {
  save?: boolean
}

export const MeasurementsBanner = observer(({ save }: Props) => {
  const banner = measurements_banner.it
  const { profile } = banner

  const onCancel = useLatestCallback(async () => {
    if (save) measurements_banner.it.profile.reset()
    measurements_banner.close()
  })

  const onSave = useLatestCallback(async () => {
    profile.common.userPhoto.measurements = true
    if (save) await controller.saveProfileOnly()
    measurements_banner.close()
  })

  const bottom = <Button large primary wide action={onSave}>
    <Typo size={14} medium upper>
      {i18n('Save')}
    </Typo>
  </Button>

  return <Banner title={i18n('Measurements')} bottom={bottom} onCancel={onCancel}>
    <Genders />
    <Gap height={16} />
    <DetailedForm />
    {store.profile.step === 'sizes' && <SizesStep />}
  </Banner>
})
